import type { QuestionStat } from '../pages/content-management/helpdesk/manage';

export const mockQuestionStats: QuestionStat[] = [
    {
        question: 'Hoe reset ik mijn wachtwoord?',
        count: 42,
        averageRating: 4.7,
        lastAsked: new Date(2025, 4, 18)
    },
    {
        question: 'Waar vind ik de facturen?',
        count: 36,
        averageRating: 4.2,
        lastAsked: new Date(2025, 4, 17)
    },
    {
        question: 'Hoe kan ik mijn abonnement opzeggen?',
        count: 28,
        averageRating: 3.9,
        lastAsked: new Date(2025, 4, 18)
    },
    {
        question: 'Wat is de PS Impact Score?',
        count: 24,
        averageRating: 4.8,
        lastAsked: new Date(2025, 4, 16)
    },
    {
        question: 'Hoe exporteer ik mijn gegevens?',
        count: 18,
        averageRating: 4.1,
        lastAsked: new Date(2025, 4, 15)
    }
]; 